/* NW Header (neu) – Menü, Fahrzeugwahl, Fahrzeug merken. 03.11.2026 */
(function () {
  'use strict';
  var root = document.querySelector('[data-nw-header]');
  if (!root || root.dataset.nwInit) return;
  root.dataset.nwInit = '1';

  var DATA = {};
  try { DATA = JSON.parse(document.getElementById('nw-menu-data').textContent); } catch (e) { DATA = { vehicles: [], groups: [], vendors: [], einsatz: [], rmi: [] }; }
  var L = {};
  try { L = JSON.parse(root.parentNode.querySelector('[data-nw-labels]').textContent); } catch (e) {}
  var sortFn = function (a, b) { return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' }); };
  var q = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var qa = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };
  var el = function (tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var nTxt = function (n) { return (n == null || n === '') ? '' : (n === 0 ? L.soon || 'bald' : n); };
  var LOGO_ALIAS = { mercedesamg: 'mercedes', mercedesbenz: 'mercedes', vw: 'volkswagen' };
  var LOGOS = {};
  qa('symbol[id^="nw-logo-"]', document).forEach(function (sy) { LOGOS[sy.id.replace('nw-logo-', '')] = true; });
  function logoId(brand) { var k = String(brand || '').toLowerCase().replace(/[^a-z0-9]/g, ''); k = LOGO_ALIAS[k] || k; return LOGOS[k] ? 'nw-logo-' + k : null; }
  var LOGOMAP = {}; try { LOGOMAP = JSON.parse(document.getElementById('nw-brand-logo-map').textContent); } catch (e) {}
  function logoKey(brand) { var k = String(brand || '').toLowerCase().replace(/[^a-z0-9]/g, ''); return LOGO_ALIAS[k] || k; }
  function logoSvg(brand, cls) { var k = logoKey(brand); if (LOGOMAP[k]) return '<img class="' + (cls || 'nw-opt__logo') + ' nw-logo-img" src="' + LOGOMAP[k] + '" alt="" loading="lazy">'; var id = logoId(brand); return id ? '<svg class="' + (cls || 'nw-opt__logo') + '" aria-hidden="true"><use href="#' + id + '"></use></svg>' : ''; }
  window.NWLogo = { id: logoId, svg: logoSvg };

  /* ---------- Fahrzeug: Baum Marke → Modell → Generation ---------- */
  var TREE = {};
  (DATA.vehicles || []).forEach(function (v) {
    var b = TREE[v.m] = TREE[v.m] || { n: 0, models: {} };
    var m = b.models[v.mo] = b.models[v.mo] || { n: 0, gens: [] };
    m.gens.push(v); m.n += (v.n || 0); b.n += (v.n || 0);
  });
  var brands = Object.keys(TREE).sort(sortFn);

  /* gemerktes Fahrzeug */
  var KEY = 'nw_fz';
  function getSaved() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function setSaved(v) {
    try { if (v) localStorage.setItem(KEY, JSON.stringify({ t: v.t, h: v.h, u: v.u, th: v.th, n: v.n, m: v.m })); else localStorage.removeItem(KEY); } catch (e) {}
    try { document.cookie = 'nw_fz=' + (v ? encodeURIComponent(v.th) : '') + '; path=/; max-age=' + (v ? 60 * 60 * 24 * 180 : 0) + '; SameSite=Lax'; } catch (e) {}
    paintSaved();
    document.dispatchEvent(new CustomEvent('nw:vehicle', { detail: v || null }));
  }
  function paintSaved() {
    var s = getSaved();
    qa('[data-nw-vehicle-label]').forEach(function (n) { n.textContent = s ? s.t : (L.choose || 'Fahrzeug wählen'); });
    var btn = q('[data-nw-trigger="fahrzeug"]'); if (btn) btn.classList.toggle('is-set', !!s);
    var lg = q('[data-nw-vehicle-logo]');
    if (lg) { var brand = s ? (s.m || (s.t || '').split(' ')[0]) : null; var k = brand ? logoKey(brand) : null;
      if (k && LOGOMAP[k]) { lg.innerHTML = '<img src="' + LOGOMAP[k] + '" alt="">'; lg.removeAttribute('hidden'); }
      else { var id = brand ? logoId(brand) : null; if (id) { lg.innerHTML = '<svg aria-hidden="true"><use href="#' + id + '"></use></svg>'; lg.removeAttribute('hidden'); } else { lg.setAttribute('hidden', ''); } } }
  }
  window.NWVehicle = { get: getSaved, set: setSaved, clear: function () { setSaved(null); }, data: DATA, labels: L };

  /* ---------- Wahl-Widget (Desktop-Panel, Mobil und Startseite teilen die Logik) ---------- */
  function makeSelector(o) {
    // o: { brands, models, gens, card:{body, empty, title, count, link, save, clear, kicker}, onPick, mobile:bool, steps:{brand,model,gen} }
    var st = { b: null, m: null, v: null };
    function mobStep(name) {
      if (!o.mobile) return;
      ['brand', 'model', 'gen'].forEach(function (k) { show(o.steps[k], k === name); });
      if (o.card && o.card.body) show(o.card.body, name === 'card');
      renderCrumbs();
      if (o.scroll) o.scroll.scrollTop = 0;
    }
    function renderCrumbs() {
      if (!o.crumbs) return; var h = '';
      if (st.b) h += '<button type="button" class="nw-crumb" data-step="brand">' + logoSvg(st.b, 'nw-crumb__logo') + '<span>' + esc(st.b) + '</span></button>';
      if (st.m) h += '<button type="button" class="nw-crumb" data-step="model"><span>' + esc(st.m) + '</span></button>';
      if (st.v && st.v.g) h += '<button type="button" class="nw-crumb" data-step="gen"><span>' + esc(st.v.g) + '</span></button>';
      o.crumbs.innerHTML = h; show(o.crumbs, !!h);
      qa('.nw-crumb', o.crumbs).forEach(function (c) { c.addEventListener('click', function () { mobStep(c.dataset.step); }); });
    }
    function renderBrands() {
      o.brands.innerHTML = '';
      brands.forEach(function (b) {
        var btn = el('button', 'nw-opt' + (st.b === b ? ' is-active' : ''), '<span class="nw-opt__lead">' + logoSvg(b) + '<span>' + esc(b) + '</span></span><span class="nw-opt__n">' + esc(nTxt(TREE[b].n)) + '</span>');
        btn.type = 'button';
        btn.addEventListener('click', function () { pickBrand(b); });
        o.brands.appendChild(btn);
      });
    }
    function pickBrand(b) {
      st.b = b; st.m = null; st.v = null;
      renderBrands(); renderModels(); renderGens(); paintCard();
      if (o.steps) { show(o.steps.model, true); show(o.steps.gen, false); }
      mobStep('model');
      var models = Object.keys(TREE[b].models).sort(sortFn);
      if (models.length === 1) pickModel(models[0]);
    }
    function renderModels() {
      o.models.innerHTML = '';
      if (!st.b) { o.models.innerHTML = '<p class="nw-vsel__hint">' + esc(L.pickBrand || '') + '</p>'; return; }
      Object.keys(TREE[st.b].models).sort(sortFn).forEach(function (m) {
        var mm = TREE[st.b].models[m];
        var btn = el('button', 'nw-opt' + (st.m === m ? ' is-active' : ''), '<span>' + esc(m) + '</span><span class="nw-opt__n">' + esc(nTxt(mm.n)) + '</span>');
        btn.type = 'button';
        btn.addEventListener('click', function () { pickModel(m); });
        o.models.appendChild(btn);
      });
    }
    function pickModel(m) {
      st.m = m; st.v = null;
      renderModels(); renderGens(); paintCard();
      var gens = TREE[st.b].models[m].gens;
      var hasGen = gens.length > 1 || (gens.length === 1 && gens[0].g);
      if (o.steps) show(o.steps.gen, hasGen);
      mobStep(hasGen ? 'gen' : 'card');
      if (gens.length === 1) pickGen(gens[0]);
    }
    function renderGens() {
      o.gens.innerHTML = '';
      if (!st.b || !st.m) return;
      var gens = TREE[st.b].models[st.m].gens.slice().sort(function (a, b) { return sortFn(a.g, b.g); });
      gens.forEach(function (v) {
        var label = v.g || v.mo;
        var btn = el('button', 'nw-opt' + (st.v === v ? ' is-active' : ''), '<span>' + esc(label) + '</span><span class="nw-opt__n">' + esc(nTxt(v.n)) + '</span>');
        btn.type = 'button';
        btn.addEventListener('click', function () { pickGen(v); });
        o.gens.appendChild(btn);
      });
    }
    function pickGen(v) { st.v = v; renderGens(); paintCard(); mobStep('card'); if (o.onPick) o.onPick(v); }
    function paintCard() {
      var c = o.card; if (!c) return;
      var s = getSaved();
      if (!st.v) {
        if (c.empty) show(c.empty, true); if (c.body) show(c.body, false);
        return;
      }
      if (c.empty) show(c.empty, false); if (c.body) show(c.body, true);
      if (c.kicker) c.kicker.textContent = L.vehicle || 'Dein Fahrzeug';
      c.title.textContent = st.v.t;
      c.count.textContent = (st.v.n == null ? '' : st.v.n + ' ' + (L.count || 'Teile'));
      c.link.href = st.v.u;
      var isSaved = s && s.h === st.v.h;
      c.save.textContent = isSaved ? (L.remembered || 'Gemerkt') : (L.remember || 'Merken');
      c.save.classList.toggle('is-done', !!isSaved);
      if (c.clear) show(c.clear, !!s);
    }
    if (o.card) {
      o.card.save.addEventListener('click', function () { if (st.v) { setSaved(st.v); paintCard(); } });
      if (o.card.clear) o.card.clear.addEventListener('click', function () { setSaved(null); paintCard(); });
    }
    function preselect(v) {
      if (!v) return;
      var found = (DATA.vehicles || []).filter(function (x) { return x.h === v.h; })[0];
      if (!found) return;
      st.b = found.m; st.m = found.mo; st.v = found;
      renderBrands(); renderModels(); renderGens(); paintCard();
      if (o.steps) { show(o.steps.model, true); show(o.steps.gen, true); }
      mobStep('card');
    }
    renderBrands(); renderModels(); renderGens(); paintCard(); mobStep('brand');
    return { preselect: preselect, repaint: function () { renderBrands(); renderModels(); renderGens(); paintCard(); }, state: st };
  }
  function show(n, yes) { if (!n) return; if (yes) n.removeAttribute('hidden'); else n.setAttribute('hidden', ''); }

  /* ---------- Spalten: Teile / Interieur / Clubsport / Hersteller ---------- */
  function colHTML(title, url, n, items, soon) {
    var h = '<div class="nw-col' + (soon ? ' nw-col--soon' : '') + '">';
    h += '<h4 class="nw-col__head"><a href="' + esc(url) + '">' + esc(title) + (soon ? ' <span class="nw-badge">' + esc(L.soon || 'bald') + '</span>' : '<span class="nw-col__n">' + esc(nTxt(n)) + '</span>') + '</a></h4>';
    if (items && items.length) {
      h += '<ul class="nw-col__list">';
      items.forEach(function (it) { h += '<li><a href="' + esc(it.u) + '"><span>' + esc(it.t) + '</span><span class="nw-col__n">' + esc(nTxt(it.n)) + '</span></a></li>'; });
      h += '</ul>';
    }
    h += '</div>';
    return h;
  }
  function groupsHTML() {
    var h = '', soonCols = [];
    (DATA.groups || []).forEach(function (g) {
      if (!g.n) { soonCols.push(g); return; }
      h += colHTML(g.t, g.u, g.n, (g.subs || []).filter(function (s) { return s.n; }));
    });
    if (soonCols.length) {
      h += '<div class="nw-col nw-col--soon"><h4 class="nw-col__head">' + esc(L.more || 'Weitere') + '</h4><ul class="nw-col__list">';
      soonCols.forEach(function (g) { h += '<li><a href="' + esc(g.u) + '" tabindex="-1" onclick="return false"><span>' + esc(g.t) + '</span><span class="nw-badge">' + esc(L.soon || 'bald') + '</span></a></li>'; });
      h += '</ul></div>';
    }
    return h;
  }
  function rmiHTML() {
    var by = {};
    (DATA.rmi || []).forEach(function (r) { (by[r.b] = by[r.b] || []).push(r); });
    var h = '';
    Object.keys(by).sort(sortFn).forEach(function (b) {
      var items = by[b].sort(function (a, c) { return sortFn(a.t, c.t); });
      var n = items.reduce(function (s, i) { return s + (i.n || 0); }, 0);
      h += colHTML(b, items[0].u, n, items);
    });
    if (!h) h = colHTML(L.rmi || 'Ready Made Interior', (DATA.collectionsUrl || '/collections') + '/ready-made-interior', null, []);
    return h;
  }
  function einsatzHTML() {
    var h = '';
    (DATA.einsatz || []).forEach(function (e) {
      h += '<a class="nw-einsatz" href="' + esc(e.u) + '"><span class="nw-einsatz__t"><span>' + esc(e.t) + '</span><span class="nw-col__n">' + esc(nTxt(e.n)) + '</span></span><p class="nw-col__desc">' + esc(e.d || '') + '</p></a>';
    });
    return h;
  }
  function vendorsHTML() {
    var h = '';
    (DATA.vendors || []).forEach(function (v) {
      h += '<a class="nw-vendor" href="' + esc(v.u) + '"><span class="nw-vendor__top">' + (v.l ? '<img class="nw-vendor__logo" data-h="' + esc(v.h) + '" src="' + esc(v.l) + '" alt="" loading="lazy">' : '<span></span>') + '<span class="nw-vendor__n">' + esc(nTxt(v.n)) + '</span></span><span class="nw-vendor__name">' + esc(v.t) + '</span><span class="nw-vendor__desc">' + esc(v.d || '') + '</span></a>';
    });
    return h;
  }
  function fill(sel, html) { qa(sel).forEach(function (n) { n.innerHTML = html; }); }
  fill('[data-nw-groups]', groupsHTML());
  fill('[data-nw-rmi]', rmiHTML());
  fill('[data-nw-einsatz]', einsatzHTML());
  fill('[data-nw-vendors]', vendorsHTML());

  /* ---------- Mobil: kompakte Zeilen + Unterseite ---------- */
  function mrow(tag, attrs, lead, title, n, chev, extra, badge) {
    return '<' + tag + ' class="nw-mrow' + (extra || '') + '"' + attrs + '>' + (lead || '') + '<span class="nw-mrow__t">' + esc(title) + '</span>' +
      (badge ? '<span class="nw-badge">' + esc(badge) + '</span>' : '') +
      (n != null ? '<span class="nw-mrow__n">' + esc(nTxt(n)) + '</span>' : '') + (chev ? '<span class="nw-mrow__chev" aria-hidden="true"></span>' : '') + '</' + tag + '>';
  }
  var subPanel = q('[data-nw-m-sub]');
  function openSub(title, html) {
    if (!subPanel) return;
    q('[data-nw-m-sub-title]').textContent = title; q('[data-nw-m-sub-body]').innerHTML = html;
    show(subPanel, true); subPanel.scrollTop = 0; requestAnimationFrame(function () { subPanel.classList.add('is-open'); });
  }
  var sback = q('[data-nw-m-sback]'); if (sback) sback.addEventListener('click', function () { subPanel.classList.remove('is-open'); });
  (function () {
    var box = q('[data-nw-m-groups]'); if (!box) return; var h = '';
    (DATA.groups || []).forEach(function (g, i) {
      if (!g.n) { h += mrow('span', '', '', g.t, null, false, ' nw-mrow--soon', L.soon || 'bald'); return; }
      h += mrow('button', ' type="button" data-mg="' + i + '"', '', g.t, g.n, true);
    });
    box.innerHTML = h;
    qa('[data-mg]', box).forEach(function (b) {
      b.addEventListener('click', function () {
        var g = DATA.groups[+b.dataset.mg]; var s = mrow('a', ' href="' + esc(g.u) + '"', '', (L.allParts || 'Alle Teile anzeigen'), g.n, true, ' nw-mrow--all');
        (g.subs || []).filter(function (x) { return x.n; }).forEach(function (x) { s += mrow('a', ' href="' + esc(x.u) + '"', '', x.t, x.n, true); });
        openSub(g.t, s);
      });
    });
  })();
  (function () {
    var box = q('[data-nw-m-rmi]'); if (!box) return; var by = {};
    (DATA.rmi || []).forEach(function (r) { (by[r.b] = by[r.b] || []).push(r); });
    var keys = Object.keys(by).sort(sortFn); var h = '';
    keys.forEach(function (b, i) { var n = by[b].reduce(function (s, x) { return s + (x.n || 0); }, 0); h += mrow('button', ' type="button" data-mr="' + i + '"', logoSvg(b, 'nw-mrow__logo'), b, n, true); });
    if (!h) h = mrow('a', ' href="' + esc((DATA.collectionsUrl || '/collections') + '/ready-made-interior') + '"', '', L.rmi || 'Ready Made Interior', null, true);
    var umbau = q('[data-nw-umbau]'); if (umbau) h += mrow('a', ' href="' + esc(umbau.getAttribute('href')) + '"', '', umbau.getAttribute('data-nw-umbau') || 'Individuelle Umbauten', null, true, ' nw-mrow--all');
    box.innerHTML = h;
    qa('[data-mr]', box).forEach(function (b) {
      b.addEventListener('click', function () {
        var k = keys[+b.dataset.mr]; var s = '';
        by[k].slice().sort(function (a, c) { return sortFn(a.t, c.t); }).forEach(function (x) { s += mrow('a', ' href="' + esc(x.u) + '"', '', x.t, x.n, true); });
        openSub(k, s);
      });
    });
  })();
  (function () {
    var box = q('[data-nw-m-einsatz]'); if (!box) return; var h = '';
    (DATA.einsatz || []).forEach(function (e) { h += mrow('a', ' href="' + esc(e.u) + '"', '', e.t, e.n, true); });
    box.innerHTML = h;
  })();
  (function () {
    var box = q('[data-nw-m-vendors]'); if (!box) return; var h = '';
    (DATA.vendors || []).forEach(function (v) { h += mrow('a', ' href="' + esc(v.u) + '"', v.l ? '<span class="nw-mrow__vlogo"><img src="' + esc(v.l) + '" alt="" loading="lazy" data-h="' + esc(v.h) + '"></span>' : '', v.t, v.n, true); });
    box.innerHTML = h;
  })();

  /* ---------- Desktop-Panels ---------- */
  var panels = {}; qa('[data-nw-panel]').forEach(function (p) { panels[p.dataset.nwPanel] = p; });
  var items = {}; qa('[data-nw-item]').forEach(function (i) { items[i.dataset.nwItem] = i; });
  var openKey = null, hoverTimer = null, closeTimer = null;
  function openPanel(key) {
    if (openKey === key) return;
    closePanel(true);
    var p = panels[key]; if (!p) return;
    p.removeAttribute('hidden');
    requestAnimationFrame(function () { p.classList.add('is-open'); });
    items[key] && items[key].classList.add('is-open');
    var t = q('[data-nw-trigger="' + key + '"]'); if (t) t.setAttribute('aria-expanded', 'true');
    root.classList.add('is-panel-open');
    openKey = key;
  }
  function closePanel(immediate) {
    if (!openKey) return;
    var p = panels[openKey], key = openKey;
    p.classList.remove('is-open');
    items[key] && items[key].classList.remove('is-open');
    var t = q('[data-nw-trigger="' + key + '"]'); if (t) t.setAttribute('aria-expanded', 'false');
    root.classList.remove('is-panel-open');
    openKey = null;
    setTimeout(function () { if (openKey !== key) p.setAttribute('hidden', ''); }, immediate ? 0 : 300);
  }
  qa('[data-nw-trigger]').forEach(function (t) {
    var key = t.dataset.nwTrigger;
    t.addEventListener('click', function (e) {
      if (window.matchMedia('(max-width: 1024px)').matches) return;
      e.preventDefault();
      if (openKey === key) closePanel(); else openPanel(key);
    });
    t.parentNode.addEventListener('mouseenter', function () {
      if (window.matchMedia('(max-width: 1024px)').matches) return;
      clearTimeout(closeTimer); clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () { openPanel(key); }, openKey ? 60 : 140);
    });
    t.parentNode.addEventListener('mouseleave', function () { clearTimeout(hoverTimer); scheduleClose(); });
  });
  function scheduleClose() { clearTimeout(closeTimer); closeTimer = setTimeout(function () { closePanel(); }, 220); }
  qa('[data-nw-panel]').forEach(function (p) {
    p.addEventListener('mouseenter', function () { clearTimeout(closeTimer); clearTimeout(hoverTimer); });
    p.addEventListener('mouseleave', scheduleClose);
  });
  var ov = q('[data-nw-overlay]'); if (ov) ov.addEventListener('click', function () { closePanel(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closePanel(); closeMobile(); } });
  document.addEventListener('click', function (e) { if (!openKey) return; var path = e.composedPath ? e.composedPath() : []; if (path.indexOf(root) === -1 && !root.contains(e.target)) closePanel(); });

  /* Desktop-Fahrzeugwahl */
  var dsel = makeSelector({
    brands: q('[data-nw-brands]'), models: q('[data-nw-models]'), gens: q('[data-nw-gens]'),
    card: { empty: q('[data-nw-vcard-empty]'), body: q('[data-nw-vcard-body]'), title: q('[data-nw-vcard-title]'), count: q('[data-nw-vcard-count]'), link: q('[data-nw-vcard-link]'), save: q('[data-nw-vcard-save]'), clear: q('[data-nw-vcard-clear]'), kicker: q('[data-nw-vcard-kicker]') }
  });
  dsel.preselect(getSaved());

  /* ---------- Mobile ---------- */
  var mob = q('[data-nw-mobile]'), mvsel = q('[data-nw-m-vsel]');
  function openMobile() { mob.classList.add('is-open'); mob.setAttribute('aria-hidden', 'false'); document.body.classList.add('nw-mobile-open'); q('[data-nw-burger]').setAttribute('aria-expanded', 'true'); }
  function closeMobile() { if (!mob) return; mob.classList.remove('is-open'); mob.setAttribute('aria-hidden', 'true'); document.body.classList.remove('nw-mobile-open'); q('[data-nw-burger]').setAttribute('aria-expanded', 'false'); if (mvsel) mvsel.classList.remove('is-open'); if (subPanel) subPanel.classList.remove('is-open'); }
  qa('[data-nw-macc]').forEach(function (b) {
    b.addEventListener('click', function () {
      var open = b.getAttribute('aria-expanded') === 'true';
      qa('[data-nw-macc]').forEach(function (o) { o.setAttribute('aria-expanded', 'false'); o.nextElementSibling.setAttribute('hidden', ''); });
      if (!open) { b.setAttribute('aria-expanded', 'true'); b.nextElementSibling.removeAttribute('hidden'); }
    });
  });
  var burger = q('[data-nw-burger]'); if (burger) burger.addEventListener('click', openMobile);
  var mclose = q('[data-nw-mobile-close]'); if (mclose) mclose.addEventListener('click', closeMobile);
  var mveh = q('[data-nw-m-vehicle]'); if (mveh) mveh.addEventListener('click', function () { show(mvsel, true); requestAnimationFrame(function () { mvsel.classList.add('is-open'); }); });
  var mback = q('[data-nw-m-vback]'); if (mback) mback.addEventListener('click', function () { mvsel.classList.remove('is-open'); });
  if (mvsel) {
    var msel = makeSelector({
      mobile: true, crumbs: q('[data-nw-m-crumbs]'), scroll: mvsel,
      brands: q('[data-nw-m-brands]'), models: q('[data-nw-m-models]'), gens: q('[data-nw-m-gens]'),
      steps: { brand: q('[data-nw-m-step="brand"]'), model: q('[data-nw-m-step="model"]'), gen: q('[data-nw-m-step="gen"]') },
      card: { body: q('[data-nw-m-card]'), title: q('[data-nw-m-card-title]'), count: q('[data-nw-m-card-count]'), link: q('[data-nw-m-card-link]'), save: q('[data-nw-m-card-save]') },
      onPick: function () { setTimeout(function () { var c = q('[data-nw-m-card]'); if (c && c.scrollIntoView) c.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 50); }
    });
    msel.preselect(getSaved());
  }

  /* Scroll-Schatten */
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () { root.classList.toggle('is-scrolled', window.scrollY > 8); ticking = false; });
  }, { passive: true });

  paintSaved();
  document.addEventListener('nw:vehicle', function () { dsel.repaint(); });
  window.NWVehicle.makeSelector = makeSelector;
  document.dispatchEvent(new CustomEvent('nw:ready'));
})();

/* Bestseller-Slider: endlos, sanft durchlaufend (Theme-Swiper neu initialisieren) */
(function () {
  var tries = 0;
  function reveal(el) {
    /* Theme-Animation (animate-motion-list) haelt Karten unsichtbar, bis sie ins Bild kommen; Klone erben das -> alles sichtbar machen */
    el.querySelectorAll('[data-motion-list]').forEach(function (n) { n.style.opacity = '1'; n.style.visibility = 'visible'; n.style.transform = 'none'; });
  }
  function init() {
    var el = document.querySelector('.featured-collection-content-wrapper .swiper');
    if (!el || el.dataset.nwLoop) return;
    var old = el.swiper;
    if (!window.Swiper || !old) { if (tries++ < 60) setTimeout(init, 400); return; }
    el.dataset.nwLoop = '1';
    var p = old.params || {};
    var nav = p.navigation && p.navigation.nextEl ? { nextEl: p.navigation.nextEl, prevEl: p.navigation.prevEl } : undefined;
    var keep = { slidesPerView: p.slidesPerView, spaceBetween: p.spaceBetween, breakpoints: p.breakpoints };
    old.destroy(true, true);
    var wrap = el.querySelector('.swiper-wrapper'); var orig = Array.prototype.slice.call(wrap.children);
    while (wrap.children.length < Math.max(12, orig.length * 3)) { orig.forEach(function (sl) { wrap.appendChild(sl.cloneNode(true)); }); }
    wrap.style.transitionTimingFunction = 'linear';
    var sw = new Swiper(el, Object.assign({}, keep, {
      loop: true, loopAdditionalSlides: 4, speed: 6000, allowTouchMove: true, grabCursor: true,
      autoplay: { delay: 0, disableOnInteraction: false, pauseOnMouseEnter: true },
      navigation: nav
    }));
    el.addEventListener('mouseenter', function () { el.querySelector('.swiper-wrapper').style.transitionTimingFunction = 'ease-out'; });
    el.addEventListener('mouseleave', function () { el.querySelector('.swiper-wrapper').style.transitionTimingFunction = 'linear'; sw.autoplay.start(); });
    reveal(el); setTimeout(function () { reveal(el); }, 800);
    if ('IntersectionObserver' in window) { new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { reveal(el); sw.update(); if (sw.autoplay) sw.autoplay.start(); } }); }, { threshold: 0.05 }).observe(el); }
    window.addEventListener('pageshow', function (e) { if (e.persisted) { reveal(el); sw.update(); if (sw.autoplay) sw.autoplay.start(); } });
  }
  if (document.readyState === 'complete') setTimeout(init, 300); else window.addEventListener('load', function () { setTimeout(init, 300); });
})();

/* FAQ-Seite: h3 + Absaetze zu Akkordeon (Neuaufbau aus dem HTML der Seite) */
(function () {
  if (!/\/pages\/faq(\/|$)/.test(location.pathname)) return;
  function init() {
    var rte = document.querySelector('.main-page-section .rte'); if (!rte || rte.dataset.nwFaq) return; rte.dataset.nwFaq = '1';
    var tmp = document.createElement('div'); tmp.innerHTML = rte.innerHTML;
    var nodes = Array.prototype.slice.call(tmp.children), html = '', open = false, k = 0;
    nodes.forEach(function (n) {
      var tag = n.tagName;
      if (tag === 'H3') {
        if (!open) { html += '<div class="nw-faq">'; open = true; }
        k++;
        html += '<div class="nw-faq__item"><button class="nw-faq__q" type="button" aria-expanded="false" aria-controls="nwfaq' + k + '">' + n.textContent.trim() + '</button><div class="nw-faq__a" id="nwfaq' + k + '">';
        html += '\u0000A';
      } else if (/^H[12]$/.test(tag)) {
        if (open) { html += '\u0000E</div>'; open = false; }
        n.classList.add('nw-faq__h'); html += n.outerHTML;
      } else {
        if (open) html += n.outerHTML; else html += n.outerHTML;
      }
    });
    if (open) html += '\u0000E</div>';
    /* Antwort-Container schliessen: Marker A oeffnet, bis zum naechsten A oder E */
    html = html.replace(/\u0000A([\s\S]*?)(?=\u0000A|\u0000E)/g, '$1</div></div>').replace(/\u0000E/g, '');
    rte.innerHTML = html;
    rte.querySelectorAll('.nw-faq__q').forEach(function (b) {
      b.addEventListener('click', function () {
        var o = b.getAttribute('aria-expanded') === 'true', a = b.nextElementSibling;
        b.setAttribute('aria-expanded', o ? 'false' : 'true');
        if (o) { a.style.maxHeight = a.scrollHeight + 'px'; requestAnimationFrame(function () { a.style.maxHeight = '0px'; a.style.opacity = '0'; }); a.addEventListener('transitionend', function te() { a.removeAttribute('data-open'); a.style.maxHeight = ''; a.removeEventListener('transitionend', te); }); }
        else { a.setAttribute('data-open', ''); a.style.maxHeight = '0px'; a.style.opacity = '0'; requestAnimationFrame(function () { a.style.maxHeight = a.scrollHeight + 'px'; a.style.opacity = '1'; }); a.addEventListener('transitionend', function te() { a.style.maxHeight = ''; a.removeEventListener('transitionend', te); }); }
      });
    });
  }
  if (document.readyState === 'complete') init(); else window.addEventListener('load', init);
})();
/* Video-Block NETZ-WERK SHOP: Kontakt-Knoepfe unter den Text */
(function () {
  function init() {
    var secs = document.querySelectorAll('.shopify-section[class*="video"]');
    secs.forEach(function (sec) {
      if (sec.dataset.nwContact) return;
      var txt = sec.textContent || ''; if (!/WhatsApp/i.test(txt)) return;
      var ps = Array.prototype.slice.call(sec.querySelectorAll('p')).filter(function (p) { return /WhatsApp/i.test(p.textContent); });
      var desc = ps[0] || sec.querySelector('h3, h2'); if (!desc) return; sec.dataset.nwContact = '1';
      var box = document.createElement('div'); box.className = 'nw-contact';
      box.innerHTML = '<a href="mailto:info@nw-shop.ch"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 6 9-6"/></svg>E-Mail</a>' +
        '<a href="tel:+41765486561"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z"/></svg>+41 76 548 65 61</a>';
      desc.parentNode.insertBefore(box, desc.nextSibling);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Footer: Sprache + Land/Waehrung als kompakte Leiste (nutzt die Shopify-Formulare des Themes) */
(function () {
  function init() {
    var box = document.querySelector('.footer-section .footer-currency-language-selector'); if (!box || box.dataset.nwLoc) return; box.dataset.nwLoc = '1';
    var fLang = box.querySelector('form[id*="language"]'), fCty = box.querySelector('form[id*="currency"]');
    var isEn = /^\/en(\/|$)/.test(location.pathname);
    var L = isEn ? { lang: 'Language', cty: 'Country / currency', more: 'All countries', less: 'Fewer countries' } : { lang: 'Sprache', cty: 'Land / Währung', more: 'Alle Länder', less: 'Weniger Länder' };
    var wrap = document.createElement('div'); wrap.className = 'nw-loc';
    /* Sprache: Dropdown mit Weltkugel */
    var NAMES = { de: 'Deutsch', en: 'English', fr: 'Français', it: 'Italiano' };
    if (fLang) {
      var cur = (fLang.querySelector('input[name="locale_code"], input[name="language_code"]') || {}).value || (isEn ? 'en' : 'de');
      var opts = Array.prototype.slice.call(fLang.querySelectorAll('button[name="locale_code"], button[name="language_code"]'));
      if (opts.length) {
        var g = document.createElement('div'); g.className = 'nw-loc__group';
        var ddl = document.createElement('div'); ddl.className = 'nw-loc__dd';
        var tl = document.createElement('button'); tl.type = 'button'; tl.className = 'nw-loc__trig'; tl.setAttribute('aria-expanded', 'false');
        tl.innerHTML = '<svg class="nw-loc__globe" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3c2.8 3 2.8 15 0 18M12 3c-2.8 3-2.8 15 0 18"/></svg><span>' + (NAMES[cur] || cur.toUpperCase()) + '</span><i class="nw-loc__chev"></i>';
        var ml = document.createElement('div'); ml.className = 'nw-loc__menu nw-loc__menu--lang'; ml.hidden = true;
        opts.forEach(function (o) {
          var bb = document.createElement('button'); bb.type = 'button'; bb.className = 'nw-loc__opt' + (o.value === cur ? ' is-on' : ''); bb.innerHTML = '<span>' + (NAMES[o.value] || o.value.toUpperCase()) + '</span><em>' + o.value.toUpperCase() + '</em>';
          bb.addEventListener('click', function () { o.click(); }); ml.appendChild(bb);
        });
        tl.addEventListener('click', function () { var o = !ml.hidden; ml.hidden = o; tl.setAttribute('aria-expanded', o ? 'false' : 'true'); });
        document.addEventListener('click', function (e) { if (!ddl.contains(e.target)) { ml.hidden = true; tl.setAttribute('aria-expanded', 'false'); } });
        ddl.appendChild(tl); ddl.appendChild(ml); g.appendChild(ddl); wrap.appendChild(g);
      }
    }
    /* Land / Waehrung */
    if (fCty) {
      var curC = (fCty.querySelector('input[name="country_code"]') || {}).value || 'CH';
      var items = Array.prototype.slice.call(fCty.querySelectorAll('button[name="country_code"]')).map(function (o) {
        return { code: o.value, name: (o.querySelector('.countryname') || o).textContent.trim(), cur: ((o.querySelector('.countrycurrency') || {}).textContent || '').trim().split(/\s+/).filter(function (v, i, a) { return a.indexOf(v) === i; }).join(' '), flag: (o.querySelector('img') || {}).src || '', btn: o };
      });
      var curItem = items.filter(function (i) { return i.code === curC; })[0];
      var g2 = document.createElement('div'); g2.className = 'nw-loc__group nw-loc__group--cty';
      g2.innerHTML = '<span class="nw-loc__label">' + L.cty + '</span>';
      var dd = document.createElement('div'); dd.className = 'nw-loc__dd';
      var trig = document.createElement('button'); trig.type = 'button'; trig.className = 'nw-loc__trig'; trig.setAttribute('aria-expanded', 'false');
      trig.innerHTML = (curItem && curItem.flag ? '<img src="' + curItem.flag + '" alt="" width="16" height="12">' : '') + '<span>' + (curItem ? curItem.cur.trim().split(' ')[0] : curC) + '</span><i class="nw-loc__chev"></i>';
      var menu = document.createElement('div'); menu.className = 'nw-loc__menu'; menu.hidden = true;
      var prio = ['CH', 'DE', 'AT', 'FR', 'IT', 'LI', 'GB'];
      var top = items.filter(function (i) { return prio.indexOf(i.code) !== -1; }).sort(function (a, b) { return prio.indexOf(a.code) - prio.indexOf(b.code); });
      var rest = items.filter(function (i) { return prio.indexOf(i.code) === -1; });
      function row(i) { var b = document.createElement('button'); b.type = 'button'; b.className = 'nw-loc__opt' + (i.code === curC ? ' is-on' : ''); b.innerHTML = (i.flag ? '<img src="' + i.flag + '" alt="" width="20" height="15">' : '') + '<span>' + i.name + '</span><em>' + i.cur.trim() + '</em>'; b.addEventListener('click', function () { i.btn.click(); }); return b; }
      top.forEach(function (i) { menu.appendChild(row(i)); });
      if (rest.length) {
        var more = document.createElement('button'); more.type = 'button'; more.className = 'nw-loc__more'; more.textContent = L.more + ' (' + rest.length + ')';
        var restBox = document.createElement('div'); restBox.className = 'nw-loc__rest'; restBox.hidden = true; rest.forEach(function (i) { restBox.appendChild(row(i)); });
        more.addEventListener('click', function () { var h = restBox.hidden; restBox.hidden = !h; more.textContent = (h ? L.less : L.more + ' (' + rest.length + ')'); });
        menu.appendChild(more); menu.appendChild(restBox);
      }
      trig.addEventListener('click', function () { var o = !menu.hidden; menu.hidden = o; trig.setAttribute('aria-expanded', o ? 'false' : 'true'); });
      document.addEventListener('click', function (e) { if (!dd.contains(e.target)) { menu.hidden = true; trig.setAttribute('aria-expanded', 'false'); } });
      dd.appendChild(trig); dd.appendChild(menu); g2.appendChild(dd); wrap.appendChild(g2);
    }
    if (wrap.children.length) { box.classList.add('nw-loc-replaced'); box.parentNode.insertBefore(wrap, box); }
  }
  if (document.readyState === 'complete') init(); else window.addEventListener('load', init);
})();

/* Live-Suche im Header: Feld aufziehen, Treffer per Predictive-Search-API (04.11.2026) */
(function () {
  var f = document.querySelector('[data-nw-search]'); if (!f || f.dataset.nwLive) return; f.dataset.nwLive = '1';
  var btn = f.querySelector('[data-nw-search-btn]'), inp = f.querySelector('[data-nw-search-input]'), close = f.querySelector('[data-nw-search-close]'), drop = f.querySelector('[data-nw-search-drop]');
  var root = f.getAttribute('data-root') || (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var timer = null, last = '', hl = -1, ctrl = null;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function open() { if (f.classList.contains('is-open')) return; f.classList.add('is-open'); inp.removeAttribute('tabindex'); setTimeout(function () { inp.focus(); }, 120); }
  function shut() { f.classList.remove('is-open'); hideDrop(); inp.value = ''; last = ''; inp.setAttribute('tabindex', '-1'); }
  function hideDrop() { drop.classList.remove('is-in'); setTimeout(function () { if (!drop.classList.contains('is-in')) { drop.setAttribute('hidden', ''); drop.innerHTML = ''; } }, 220); hl = -1; }
  function showDrop(html) { drop.innerHTML = html; drop.removeAttribute('hidden'); requestAnimationFrame(function () { drop.classList.add('is-in'); }); hl = -1; }
  var fmt = null; try { fmt = new Intl.NumberFormat('de-CH', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CHF' }); } catch (e) {}
  function money(p) { var n = parseFloat(p.price); if (isNaN(n)) return p.price || ''; return fmt ? fmt.format(n) : ('CHF ' + n.toFixed(2)); }
  function render(q, res) {
    var prods = (res && res.resources && res.resources.results && res.resources.results.products) || [];
    if (!prods.length) { showDrop('<div class="nw-search__none">' + esc(f.getAttribute('data-l-none')) + ' «' + esc(q) + '»</div>'); return; }
    var h = '';
    prods.forEach(function (p) {
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_120x120_crop_center$1$2') : '';
      h += '<a class="nw-search__item" href="' + esc(p.url) + '">' + (img ? '<img class="nw-search__thumb" src="' + esc(img) + '" alt="" loading="lazy">' : '<span class="nw-search__thumb"></span>') +
        '<span class="nw-search__t"><span class="nw-search__title">' + esc(p.title) + '</span><span class="nw-search__meta">' + esc(p.vendor || '') + (p.price ? ' · ' + esc(money(p)) : '') + '</span></span></a>';
    });
    h += '<a class="nw-search__all" href="' + esc(root.replace(/\/$/, '')) + '/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last"><span>' + esc(f.getAttribute('data-l-all')) + '</span><span>«' + esc(q) + '»</span></a>';
    showDrop(h);
  }
  function query() {
    var q = inp.value.trim(); if (q === last) return; last = q;
    if (q.length < 2) { hideDrop(); return; }
    if (ctrl) ctrl.abort(); ctrl = new AbortController();
    fetch(root.replace(/\/$/, '') + '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku,tag', { signal: ctrl.signal })
      .then(function (r) { return r.json(); }).then(function (j) { if (inp.value.trim() === q) render(q, j); }).catch(function () {});
  }
  btn.addEventListener('click', function () { if (f.classList.contains('is-open')) { if (inp.value.trim()) f.submit(); else shut(); } else open(); });
  close.addEventListener('click', shut);
  inp.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(query, 160); });
  inp.addEventListener('keydown', function (e) {
    var items = drop.querySelectorAll('.nw-search__item, .nw-search__all');
    if (e.key === 'Escape') { shut(); return; }
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { if (!items.length) return; e.preventDefault(); hl = (hl + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length; items.forEach(function (it, i) { it.classList.toggle('is-hl', i === hl); }); items[hl].scrollIntoView({ block: 'nearest' }); return; }
    if (e.key === 'Enter' && hl >= 0 && items[hl]) { e.preventDefault(); location.href = items[hl].href; }
  });
  document.addEventListener('click', function (e) { if (f.classList.contains('is-open') && !f.contains(e.target)) shut(); });
  document.addEventListener('keydown', function (e) { if (e.key === '/' && !/input|textarea|select/i.test((e.target || {}).tagName || '') && window.matchMedia('(min-width: 1025px)').matches) { e.preventDefault(); open(); } });
})();
